import queryString from "query-string";

const currentQueryObject = filterState => {
  const { account, period, granularity } = filterState;
  const result = {};
  if (account.selected.id) {
    result.account = account.selected.id;
  }

  if (Object.keys(period).length === 2) {
    result.start = period.start.format("YYYY-MM-DD");
    result.end = period.end.format("YYYY-MM-DD");
  }

  if (granularity) {
    result.granularity = granularity;
  }
  return result;
};

/*

*/
export const setQueryToPeriod = (currentfilterState, section, period) => {
  const currentQuery = currentQueryObject(currentfilterState);

  const newPeriod = {
    start: period.start.format("YYYY-MM-DD"),
    end: period.end.format("YYYY-MM-DD")
  };

  const newQuery = { ...currentQuery, ...newPeriod };
  const str = queryString.stringify(newQuery);
  return `/overview/${section}?${str}`;
};

export const setQueryToEntity = (currentfilterState, section, entity) => {
  const query = currentQueryObject(currentfilterState);
  const { key, value } = entity;

  if (typeof value === "object") {
    Object.assign(query, { [key]: value.id });
  } else {
    delete query[key];
  }

  return `/overview/${section}?${queryString.stringify(query)}`;
};

export const setQueryToKeyValue = (currentfilterState, section, key, value) => {
  const currentQuery = currentQueryObject(currentfilterState);
  const newQuery = { ...currentQuery, [key]: value };
  return `/overview/${section}?${queryString.stringify(newQuery)}`;
};

const mergePeriod = (query, period) => {
  let newQuery = { ...query };
  if (period) {
    const newPeriod = {
      start: period.start.utc().format("YYYY-MM-DD"),
      end: period.end.utc().format("YYYY-MM-DD")
    };
    return { ...newQuery, ...newPeriod };
  }
  return query;
};

const mergeEntities = (query, entities) => {
  if (!(entities && entities.length > 0)) {
    return query;
  }
  let newQuery = { ...query };
  entities.forEach(entity => {
    const { key, value } = entity;
    if (typeof value === "object") {
      newQuery = { ...newQuery, [key]: value.id };
    } else {
      delete newQuery[key];
    }
  });
  return newQuery;
};

const mergeSimpleParams = (query, params) => {
  return { ...query, ...params };
};

export const modifyQuery = (currentfilterState, section, params) => {
  let query = currentQueryObject(currentfilterState);
  query = mergePeriod(query, params.period);
  query = mergeEntities(query, params.entities);
  query = mergeSimpleParams(query, params.simpleParams);
  return `/overview/${section}?${queryString.stringify(query)}`;
};



// WEBPACK FOOTER //
// ./src/helpers/overviewUrl.js